import React from 'react';
import css from './index.css';
import {Box,Grid, Paper, Card, CardActions, Typography,CardContent, List, ListItemText,ListItem} from '@material-ui/core';
import {Code} from '@material-ui/icons';

export default function Skills() {
    return (
        <Box>
        <Grid style={{ marginTop:20,marginBottom:20 }} container spacing={1}>
        <Grid item xs={12}>
        <Grid container justify="center" spacing={8}>
        <Grid item>
        <Paper style={{width:300}}>
        <Card>
        <CardActions>
        <CardContent>
        <Typography align="center">
        <h1 className="cardtitle">Front-end development</h1>
        </Typography>
        <List>
        <ListItem> <Code/> 
        <ListItemText primary=" React JS (React-Redux)" />
        </ListItem>
        <ListItem> <Code/> 
        <ListItemText primary=" Vue Js (Vuex)" />
        </ListItem>
        <ListItem> <Code/> 
        <ListItemText primary=" Bootstrap" />
        </ListItem>
        <ListItem> <Code/> 
        <ListItemText primary=" CSS3/SCSS" />
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </Paper>
        </Grid>
        <Grid item>
        <Paper style={{width:300}}>
        <Card>
        <CardActions>
        <CardContent>
        <Typography align="center">
        <h1 className="cardtitle">Back-end development </h1>
        </Typography>
        <List>
        <ListItem> <Code/> 
        <ListItemText primary=" Node Js (ExpressJS)" />
        </ListItem>
        <ListItem> <Code/>
        <ListItemText primary="Laravel" />
        </ListItem>
        <ListItem>
        <ListItemText primary="MongoDB" />
        </ListItem>
        <ListItem>
        <ListItemText primary="MySql" />
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </Paper>
        </Grid>
        <Grid item>
        <Paper style={{width:300}}>
        <Card>
        <CardActions>
        <CardContent>
        <Typography align="center">
        <h1 className="cardtitle">Mobile Development</h1>
        </Typography>
        <List>
        <ListItem> <Code/> 
        <ListItemText primary="Flutter" />
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </Paper>
        </Grid>
        </Grid>
        </Grid>
        </Grid>
        </Box>
    );
}